export default __webpack_public_path__ + "static/media/community-service-1.de62299a.jpg";